<div style="margin-left: 5vw; margin-top: 10vh; width: 90vw; min-width: 50vw">
   <div style="padding-bottom: 5vh">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="inline-form">
         <mat-form-field appearance="standard">
            <mat-label>Csoport</mat-label>
            <mat-select formControlName="group">
               <mat-option *ngFor="let group of groups" [value]="group">
                  {{ group | translate }}
               </mat-option>
            </mat-select>
         </mat-form-field>

         <mat-form-field appearance="standard">
            <mat-label>Kód</mat-label>
            <input matInput formControlName="code" />
         </mat-form-field>

         <mat-form-field appearance="standard">
            <mat-label>Érték</mat-label>
            <input matInput formControlName="value" />
         </mat-form-field>

         <button mat-raised-button color="secondary" type="submit" [disabled]="form.invalid">
            Küldés
         </button>

         <button mat-raised-button color="warn" type="reset" (click)="onDiscard()"> Mégse </button>
      </form>

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" [width]="'100%'">
         <ng-container matColumnDef="group">
            <th mat-header-cell *matHeaderCellDef>{{ 'Group' | translate }}</th>
            <td mat-cell *matCellDef="let item">{{ item.group | translate }}</td>
         </ng-container>

         <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef>{{ 'Code' | translate }}</th>
            <td mat-cell *matCellDef="let item">{{ item.code }}</td>
         </ng-container>

         <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>{{ 'Value' | translate }}</th>
            <td mat-cell *matCellDef="let item">{{ item.value }}</td>
         </ng-container>

         <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef style="width: 40px"></th>
            <td mat-cell *matCellDef="let item" style="width: 40px">
               <div style="display: flex; align-items: end">
                  <button
                     mat-icon-button
                     style="margin: auto; text-align: center"
                     (click)="onEdit(item)"
                     [disabled]="!hasResource(Resources.DictEdit)"
                  >
                     <mat-icon>edit</mat-icon>
                  </button>
                  <button
                     mat-icon-button
                     (click)="onDelete(item)"
                     color="warn"
                     [disabled]="!hasResource(Resources.DictDelete)"
                  >
                     <mat-icon>delete</mat-icon>
                  </button>
               </div>
            </td>
         </ng-container>

         <tr mat-header-row *matHeaderRowDef="columns"></tr>
         <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
   </div>
</div>
